import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { config } from '../app.config';
import { map } from 'rxjs/operators';
import { IPictureData } from '../shared/components/picture/picture.component';
import { ISiteSettings } from '../shared/interface/site-settings';
import { IAgreementTextItem } from '../dynamic-module/lib/panel/subscribe-panel/subscribe-panel.component';
import { of } from 'rxjs';
import { IInitialPageData } from '../shared/interface/general';
import get from 'lodash.get';

export interface IFooterSubscription {
  agreement?: IAgreementTextItem;
}

export interface ISiteSettingsResponse {
  headerSubLinks?: any;
  footerLogo?: IPictureData;
  footerItems?: any;
  siteTitle?: string;
  siteLogo?: IPictureData;
  cookieTitle?: string;
  cookieDescription?: string;
  culture: string;
  pageTitleSeparator: string;
  footerSubscription: IFooterSubscription;
  pageNotFoundPageUrl: string;
}
@Injectable({
  providedIn: 'root'
})
export class SiteSettingsService {
  initialPageData: IInitialPageData | null = JSON.parse(get(document.getElementById('initialPageData'), 'innerHTML') || null);
  private cache: ISiteSettings;

  constructor(
    private http: HttpClient
  ) { }

  async getSiteSettings()
  {
   if (!this.cache)
   {
    if (this.initialPageData && this.initialPageData.siteSettings) {
      this.cache = this.mapData(this.initialPageData.siteSettings);
    } else {
      this.cache = await this.loadSettings().toPromise();
    }

     return this.cache;
   }

   return this.cache;
  }

  private loadSettings()
  {
    return this.http.get<ISiteSettingsResponse>(`${config.api}/siteSettings/get`).pipe(
      map(response => this.mapData(response))
    )
  }

  private mapData(response: ISiteSettingsResponse)
  {
    return {
      culture: response.culture,
      pageTitleSeparator: response.pageTitleSeparator,
      headerSettings: {
        headerSubLinks: response.headerSubLinks,
        siteTitle: response.siteTitle,
        siteLogo: response.siteLogo
      },
      footerSettings: {
        footerLogo: response.footerLogo,
        footerItems: response.footerItems,
        footerSubscription: response.footerSubscription,
      },
      cookieSettings: {
        cookieTitle: response.cookieTitle,
        cookieDescription: response.cookieDescription
      },
      pageNotFoundPageUrl: response.pageNotFoundPageUrl
    }
  }
}